import { useQuery } from "@tanstack/react-query";
import { TourSummary } from "@/types/dto/pdp/pdp-tour-summary";
import tourSummaryFactory from "@/factories/pdp/pdp-tour-summary-factories";

export const fetchTourSummaryData = (
  packageId: string,
  packageDateId: string,
  neoId: string,
  marketId: string,
  currencyId: string,
  contentfulData?: any
) => async (): Promise<TourSummary> => {
  try {
    const url = `/api/pdp/tour-summary?packageId=${packageId}&packageDateId=${packageDateId}&neoId=${neoId}&marketId=${marketId}&currencyId=${currencyId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    const rawTourSummary = await response.json();
    return tourSummaryFactory(rawTourSummary, contentfulData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error sending GET request:", error); // TODO: log error to error tracking service
    throw error;
  }
};

const useTourSummary = (
  packageId: string,
  packageDateId: string,
  neoId: string,
  currencyId: string,
  marketId: string,
  contentfulData?: any,
  enabled: boolean = true

) => useQuery<TourSummary>({
  queryKey: ["PDP_TOUR_SUMMARY", neoId, packageId, packageDateId, currencyId, marketId],
  queryFn: fetchTourSummaryData(packageId, packageDateId, neoId, marketId, currencyId, contentfulData),
  enabled: enabled && !!currencyId && !!marketId,
  staleTime: Infinity
});

export default useTourSummary;
